<template>
  <component
    :is="componentName"
    v-if="checkScreenDevice(['mobile', 'tablet'])"
    to="body"
  >
    <div class="mobile-popup position-fixed height--100vh">
      <fade-transition :duration="500">
        <div
          class="mobile-popup__cover"
          v-if="show"
          @click.stop="setShow(false)"
        />
      </fade-transition>
      <div
        class="mobile-popup__content h-auto"
        :class="{ 'bottom-percent-0': show, 'bottom--100vh': !show }"
        @click.stop="() => {}"
      >
        <div class="mobile-popup__expanded-box">
          <span class="mobile-popup__expanded" />
        </div>
        <div class="mobile-popup__body" :class="{ 'has-footer': hasFooter }">
          <slot name="default" />
        </div>
        <div class="mobile-popup__footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </component>
</template>

<script>
import Teleport from "vue2-teleport";
import { computed, toRefs } from "vue";
import { checkScreenDevice } from "@/shared/utils";
export default {
  components: { Teleport },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { show } = toRefs(props);

    const setShow = (value) => emit("setShow", value);

    const componentName = computed(() =>
      checkScreenDevice(["desktop"]) ? "div" : "Teleport"
    );

    // return data to be used in template
    return {
      show,
      setShow,
      checkScreenDevice,
      componentName,
    };
  },
};
</script>
